import React from 'react';
import {CARDBACK} from '../assets/gameData';

export const Card = ({src, alt, className}) => {
    const uA = navigator.userAgent.toLowerCase();
    const isSafari = uA.indexOf('safari') !== -1 && uA.indexOf('chrome') === -1; // safari work makes its own dragCopy and disallows dragging out of the browser on its own

    return (
        <div className={className ? className + " img" : "img"} style={{backgroundImage:'url('+src+')'}}>
            <img src={!isSafari ? CARDBACK : src} alt={alt} onContextMenu={(e)=> e.preventDefault()} />
        </div>
    );
};